// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ValueDisplayGroup-base__ZOEBd{display:flex;flex-direction:column;gap:var(--size-3);width:var(--size-full)}.ValueDisplayGroup-horizontalGroup__bvy9P{display:flex;flex-direction:column;gap:var(--size-1)}.ValueDisplayGroup-verticalGroup___L7rX{display:flex;flex-direction:column;gap:var(--size-3)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ValueDisplayGroup-base__ZOEBd",
	"horizontalGroup": "ValueDisplayGroup-horizontalGroup__bvy9P",
	"verticalGroup": "ValueDisplayGroup-verticalGroup___L7rX"
};
export default ___CSS_LOADER_EXPORT___;
